
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prediction/leaderboard",
      function () {
        return require("private-next-pages/prediction/leaderboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prediction/leaderboard"])
      });
    }
  